/**
 * Re-key a filename-keyed PDF-password map to an S3-key-keyed one.
 *
 * The frontend collects passwords keyed by the file's NAME (that's all the
 * password modal knows), but the backend looks them up as `filePasswords[s3Key]`
 * (see raf-backend handler-factory / process-raf-extract-fields). At upload time
 * the presigned-URL / upload result carries both the `filename` and its S3 `key`,
 * so this maps one to the other.
 *
 * Single source of truth for the transform, shared by the matter-extraction path
 * (`MatterDetailView`) and the generic upload hooks (`useUploadForm`,
 * `useDualUploadForm`).
 */
export function reKeyPasswordsByS3Key(
  uploaded: ReadonlyArray<{ filename: string; key: string }>,
  passwordsByFilename: Record<string, string>,
): Record<string, string> {
  const byS3Key: Record<string, string> = {};
  for (const u of uploaded) {
    const password = passwordsByFilename[u.filename];
    if (password) byS3Key[u.key] = password;
  }
  return byS3Key;
}
